import { createBrowserRouter } from 'react-router-dom'
import { AppShell } from '@/components/layout/AppShell'
import { AuthGuard } from '@/components/AuthGuard'
import { LandingPage } from '@/pages/Landing'
import { LoginPage } from '@/pages/Login'
import { DashboardPage } from '@/pages/Dashboard'
import { NodesPage } from '@/pages/Nodes'
import { NodeDetailPage } from '@/pages/NodeDetail'
import { StacksPage } from '@/pages/Stacks'
import { StackDetailPage } from '@/pages/StackDetail'
import { ServicesPage } from '@/pages/Services'
import { ServiceDetailPage } from '@/pages/ServiceDetail'
import { HealthChecksPage } from '@/pages/HealthChecks'
import { NetworkPage } from '@/pages/Network'
import { NotFoundPage } from '@/pages/NotFound'
import { AlertsPage } from '@/pages/Alerts'
import { AlertDetailPage } from '@/pages/AlertDetail'
import { SettingsNotificationsPage } from '@/pages/SettingsNotifications'
import { MaintenanceWindowsPage } from '@/pages/MaintenanceWindows'
import { AlertRulesPage } from '@/pages/AlertRules'
import { PowerSettingsPage } from '@/pages/PowerSettings'
import { BackupsPage } from '@/pages/Backups'
import { ErrorsPage } from '@/pages/Errors'
import { ErrorDetailPage } from '@/pages/ErrorDetail'
import { AuditLogPage } from '@/pages/AuditLog'
import { KioskPage } from '@/pages/Kiosk'

export const router = createBrowserRouter([
  { path: '/', element: <LandingPage /> },
  { path: '/login', element: <LoginPage /> },
  { path: '/kiosk', element: <KioskPage /> },
  {
    element: (
      <AuthGuard>
        <AppShell />
      </AuthGuard>
    ),
    children: [
      { path: '/dashboard', element: <DashboardPage /> },
      { path: '/nodes', element: <NodesPage /> },
      { path: '/nodes/:id', element: <NodeDetailPage /> },
      { path: '/stacks', element: <StacksPage /> },
      { path: '/stacks/:name', element: <StackDetailPage /> },
      { path: '/services', element: <ServicesPage /> },
      { path: '/services/:id', element: <ServiceDetailPage /> },
      { path: '/health', element: <HealthChecksPage /> },
      { path: '/network', element: <NetworkPage /> },
      { path: '/alerts', element: <AlertsPage /> },
      { path: '/alerts/:id', element: <AlertDetailPage /> },
      { path: '/settings/notifications', element: <SettingsNotificationsPage /> },
      { path: '/settings/maintenance', element: <MaintenanceWindowsPage /> },
      { path: '/settings/rules', element: <AlertRulesPage /> },
      { path: '/settings/power', element: <PowerSettingsPage /> },
      { path: '/backups', element: <BackupsPage /> },
      { path: '/errors', element: <ErrorsPage /> },
      { path: '/errors/:id', element: <ErrorDetailPage /> },
      { path: '/audit', element: <AuditLogPage /> },
    ],
  },
  { path: '*', element: <NotFoundPage /> },
])
